const autoNgTemplateLoaderTemplate1 = require('./porAccessControlPanel.html');

angular.module('shbdeployer.app').component('porAccessControlPanel', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'porAccessControlPanelController',
  bindings: {
    // Идентификатор ресурса, используемый при обновлении объекта управления доступом.
    resourceId: '<',
    // Объект управления доступом, сведения о котором отображает компонент.
    resourceControl: '=',
    // Тип связанного ресурса (компонент обычно размещается на странице сведений о ресурсе).
    // Допустимые значения: 'container', 'service' или 'volume'.
    resourceType: '<',
    // Позволяет запретить смену владельца по причинам, не связанным с объектом управления доступом.
    disableOwnershipChange: '<',
  },
});
